import { combineReducers } from 'redux';

import deleteSiteAliasError from './deleteSiteAliasError';
import createSiteAliasError from './createSiteAliasError';

export default combineReducers({
  deleteSiteAliasError,
  createSiteAliasError,
});
